import { type StoreActionApi } from 'react-sweet-state';

import type { ResearchStepRenderMode } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import type { ChatMessageResearchStore } from './types';
import { updateStep } from './updateStep';

type SetStepTitleArgs = {
	messageId: string;
	stepId: string;
	title: string;
	roundId: number;
	immediate: boolean;
	isSkill?: boolean;
	toolIcon?: string;
	toolName?: string;
	renderMode?: ResearchStepRenderMode;
	/**
	 * Whether the step is already complete. Defaults to false. Set true for terminal steps that
	 * never receive a RESEARCH_STEP_COMPLETE (e.g. the trailing "Guard redacting" step), so they do
	 * not flip `researchCompleted` back to false and revive the thinking indicator (PRGD-520).
	 */
	completed?: boolean;
};

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const setStepTitle: (args: SetStepTitleArgs) => ChatMessageResearchStoreAction =
	({
		messageId,
		stepId,
		title,
		roundId,
		immediate,
		isSkill = false,
		toolIcon,
		toolName,
		renderMode,
		completed = false,
	}) =>
	({ dispatch }: StoreActionApi<ChatMessageResearchStore>) => {
		dispatch(
			updateStep({
				messageId,
				stepId,
				updater: (step) => ({
					...step,
					title,
					roundId,
					isSkill,
					immediate,
					completed,
					toolIcon,
					toolName,
					renderMode,
				}),
			}),
		);
	};
